Vue.component('memberInfo', {
    template: `
        <div id="memberInfo">
            <div class="exports" v-if="!isExport">
                <span @click="sendEmail" v-if="$user.email">
                    <i class="fas fa-envelope"></i> Email
                </span>
                <span @click="printMember">
                    <i class="fas fa-print"></i> {{ $language.print }}
                </span>
                <span @click="exportHtml">
                    <i class="fas fa-file-export"></i> {{ $language.export }}
                </span>
            </div>
            <nav class="navbar navbar-light bg-light" v-if="memberData != {} && !isExport" id="memberNavbar">
                <a class="navbar-brand" href="#">
                    <img src="img/patbase_white.gif" alt="Patbase Logo" />
                </a>

                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" href="#title">
                            {{ $language.bibData }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="memberData.c_abstracts">
                        <a class="nav-link" href="#abstract">
                            {{ $language.abstracts }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="memberData.c_claims">
                        <a class="nav-link" href="#claims">
                            {{ $language.claims }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="memberData.c_descriptions">
                        <a class="nav-link" href="#description">
                            {{ $language.desc }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="readJSON(memberData.c_backwardcitations).length > 0 || readJSON(memberData.c_forwardcitations).length > 0">
                        <a class="nav-link" href="#citations">
                            {{ $language.citations }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="memberData.c_legalstatuses">
                        <a class="nav-link" href="#legalstatus">
                            {{ $language.legStat }}
                        </a>
                    </li>
                    <li class="nav-item" v-if="memberData.c_drawingscount">
                        <a class="nav-link" href="#images">
                            {{ $language.imgs }}
                        </a>
                    </li>
                </ul>

            </nav>

            <div id="documentContent" class="docWrapper container-fluid" v-if="memberData" data-spy="scroll" data-target="memberNavbar" data-offset="0" ref="docWrapper">

                <div id="title" class="docTitle">

                    <h4 v-if="memberData.c_titles">
                        <img :src="$setupPath + '../images/flags/png/' + memberData.c_country + '.png'" alt="" class="img-fluid jurisFlag"/>
                        {{ memberData.c_publicationnumber }} ({{ memberData.c_kindcode }}) - {{ getMainTitle((memberData.c_titles_mt)?memberData.c_titles.concat(memberData.c_titles_mt):memberData.c_titles) }}
                    </h4>

                    <small>
                        <span class="deadAlive" :class="{dead:memberData.c_dead, alive:!memberData.c_dead}">▮</span>
                        {{ (memberData.c_dead)?'Dead':'Alive' }}
                        &nbsp;&nbsp;
                        <template v-if="memberData.c_expirydate || memberData.c_assumedexpirydate">
                            <b>Expected expiry date</b>: {{ memberData.c_expirydate || memberData.c_assumedexpirydate }}
                        </template>
                        &nbsp;&nbsp;
                        <b>{{ $language.famNumber }}</b>: {{ fn }}
                        &nbsp;&nbsp;
                        <template v-if="memberData.c_updateweek">
                            <b>{{ $language.pUpWeek }}</b>: {{ (member.c_updateweek)?paddy(member.c_updateweek, 4):'' }}
                        </template>
                    </small>

                    <div class="links">
                        <template v-if="link.url">
                            <a class="externalLink" :href="link.url" target="_blank" data-toggle="tooltip" :title="$language.viewOn.replace('[WEBSITE]', link.tooltip)">
                                <img :src="'img/' + link.logo + '.png'" :alt="link.tooltip" />
                            </a>
                        </template>
                        <a class="externalLink" :href="espacenetLink" target="_blank" data-toggle="tooltip" :title="$language.viewOn.replace('[WEBSITE]', 'Espacenet')">
                            <img :src="'img/espacenet.png'" alt="Espacenet" />
                        </a>
                    </div>

                </div>

                <div class="docSection" id="biblioData">

                    <div class="sectionHeader">
                        {{ $language.bibData }}
                    </div>

                    <div class="content container-fluid">

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.publication }}</b>
                            </div>

                            <div class="col-md-10">

                                <div class="row bottomBorder">
                                    <div class="col-2">
                                        <b>{{ $language.number }}</b>
                                    </div>
                                    <div class="col-10">
                                        {{ memberData.c_publicationnumber }}&nbsp;
                                        <a v-if="showLink(memberData.c_publicationnumber, memberData.c_kindcode, member.c_country)" class="pdfLink" target="_blank" :href="'https://www.patbase.com/getimg/vvpdf.asp?vpdf=1&PN='+ memberData.c_publicationnumber +'&KD='+ memberData.c_kindcode + (($user.id)?'&id=' + $user.id:'')">
                                            {{ $language.viewOrg }} <i class="fas fa-file-pdf"></i>
                                        </a>
                                    </div>
                                </div>

                                <div class="row bottomBorder">
                                    <div class="col-2">
                                        <b>{{ $language.kd }}</b>
                                    </div>
                                    <div class="col-10">{{ memberData.c_kindcode }}</div>
                                </div>

                                <div class="row bottomBorder">
                                    <div class="col-2">
                                        <b>{{ $language.date }}</b>
                                    </div>
                                    <div class="col-10">{{ memberData.c_publicationdate }}</div>
                                </div>
                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.application }}</b>
                            </div>

                            <div class="col-md-10">

                                <div class="row bottomBorder">
                                    <div class="col-2">
                                        <b>{{ $language.number }}</b>
                                    </div>
                                    <div class="col-10">{{ memberData.c_applicationnumber }} <template v-if="memberData.c_originalapplicationnumber">[{{ formatApplicationNumber(memberData.c_originalapplicationnumber) }}]</template></div>
                                </div>

                                <div class="row bottomBorder">
                                    <div class="col-2">
                                        <b>{{ $language.date }}</b>
                                    </div>
                                    <div class="col-10">{{ memberData.c_applicationdate }}</div>
                                </div>

                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>Classifications</b>
                            </div>

                            <div class="col-md-10">

                                <div class="row bottomBorder" v-if="memberData.c_cpcvalues">
                                    <div class="col-2">
                                        <b>CPC</b>
                                    </div>
                                    <div class="col-10"> <template v-for="cpc in memberData.c_cpcvalues">{{ cpc }} </template> </div>
                                </div>

                                <div class="row bottomBorder" v-if="memberData.c_ipcvalues">
                                    <div class="col-2">
                                        <b>IPC</b>
                                    </div>
                                    <div class="col-10"> <template v-for="ipc in memberData.c_ipcvalues">{{ ipc }} </template> </div>
                                </div>

                                <div class="row bottomBorder" v-if="memberData.c_usclassifications">
                                    <div class="col-2">
                                        <b>USC</b>
                                    </div>
                                    <div class="col-10"> <template v-for="usc in memberData.c_usclassifications">{{ usc }} </template> </div>
                                </div>

                                <div class="row bottomBorder" v-if="memberData.c_jpftvalues">
                                    <div class="col-2">
                                        <b>JP</b>
                                    </div>
                                    <div class="col-10"> <template v-for="jp in memberData.c_jpftvalues">{{ jp.replace(' ', '/') }} </template> </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.priority }}</b>
                            </div>

                            <div class="col-md-10">

                                <div class="row bottomBorder">
                                    <!--<div class="col-2">
                                        <b>{{ $language.numbers }}</b>
                                    </div>-->
                                    <div class="col-12">
                                        {{ buildPriorityString(memberData.c_priorities)}}
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.inventors }}</b>
                            </div>

                            <div class="col-md-10 bottomBorder">
                                {{ getNames(memberData.c_inventors).join(' | ') }}
                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.assignees }}</b>
                            </div>

                            <div class="col-md-10 bottomBorder">
                                {{ getNames(memberData.c_assignees).join(' | ') }}
                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ $language.titles }}</b>
                            </div>

                            <div class="col-md-10 bottomBorder" v-if="memberData.c_titles">
                                <div v-for="title in uniqueTitles((memberData.c_titles_mt)?memberData.c_titles.concat(memberData.c_titles_mt):memberData.c_titles)">
                                    <b>[{{ title.lang.toUpperCase() }}]</b> {{ title.text }}
                                </div>
                            </div>

                        </div>

                        <div class="row imgRow" v-if="memberData.c_drawingscount">

                            <div class="col-md-2 biblioCategory">
                                <b>First Image</b>
                            </div>

                            <div class="col-md-10">
                                <img @click="showLightBox(1)" :src="imgUrl + '1'" class="img-fluid" />
                            </div>

                        </div>

                    </div>

                </div>

                <div class="docSection" id="abstract" v-if="memberData.c_abstracts">

                    <div class="sectionHeader">
                        {{ $language.abstracts }}
                    </div>

                    <div class="content container-fluid" :class="{hasMt: hasMt('abstracts') != false}">

                        <div v-for="abstract in memberData.c_abstracts" v-if='abstract.match(/lang="mt"/) == null' v-html="buildLangString(abstract)"></div>

                        <div v-if="hasMt('abstracts') != false && showMt('abstracts') == true" v-html="'<b>Machine Translation:</b><br>' + removeBrs(hasMt('abstracts'))"></div>

                    </div>

                </div>

                <div class="docSection" id="claims" v-if="memberData.c_claims">

                    <div class="sectionHeader">
                        {{ $language.claims }}
                    </div>

                    <div class="content container-fluid" :class="{hasMt: hasMt('claims') != false}">

                        <div v-for="claims in memberData.c_claims" v-if='claims.match(/lang="mt"/) == null' v-html="buildLangString(claims)"></div>

                        <div v-if="hasMt('claims') != false && showMt('claims') == true" v-html="'<b>Machine Translation:</b><br>' + removeBrs(hasMt('claims'))"></div>

                    </div>

                </div>

                <div class="docSection" id="description" v-if="memberData.c_descriptions">

                    <div class="sectionHeader">
                        {{ $language.desc }}
                    </div>

                    <div class="content container-fluid" :class="{hasMt: hasMt('descriptions') != false}">

                        <div v-html="removeBrs(memberData.c_descriptions[0])"></div>

                        <div v-if="hasMt('descriptions') != false && showMt('descriptions') == true" v-html="'<b>Machine Translation:</b><br>' + removeBrs(hasMt('descriptions'))"></div>

                    </div>

                </div>

                <div class="docSection" id="citations" v-if="readJSON(memberData.c_backwardcitations).length > 0 || readJSON(memberData.c_forwardcitations).length > 0">

                    <div class="sectionHeader">
                        {{ $language.citations }}
                    </div>

                    <div class="content container-fluid">

                        <div class="row" v-if="readJSON(memberData.c_backwardcitations).length > 0">

                            <div class="col-md-2 biblioCategory">
                                <b>Citing</b>
                            </div>

                            <div class="col-md-10">
                                <div class="row bottomBorder">
                                    <div class="col-12">
                                        <template v-for="citation in readJSON(memberData.c_backwardcitations)">

                                            {{ citation.PublicationNumber }}{{ (citation.KindCode)?'('+citation.KindCode+')':'' }}{{ (citation.Year)?' ['+citation.Year+']':'' }};&nbsp;

                                        </template>
                                    </div>
                                </div>


                            </div>

                        </div>

                        <div class="row" v-if="readJSON(memberData.c_forwardcitations).length > 0">

                            <div class="col-md-2">
                                <b>Cited By</b>
                            </div>

                            <div class="col-md-10 biblioCategory">

                                <template v-for="citation in readJSON(memberData.c_forwardcitations)">

                                    {{ citation.PublicationNumber }}{{ (citation.KindCode)?'('+citation.KindCode+')':'' }}{{ (citation.Year)?' ['+citation.Year+']':'' }};&nbsp;

                                </template>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="docSection" id="legalstatus">

                    <div class="sectionHeader">
                        {{ $language.legStat }}
                    </div>

                    <div class="content container-fluid">

                        <div class="row bottomBorder" v-for="(status, index) in readJSON(memberData.c_legalstatuses)">

                            <div class="col-md-2 biblioCategory">
                                <b>{{ index + 1 }}</b>
                            </div>

                            <div class="col-md-10">

                                <div class="row bottomBorder" v-if="status.EventDate">
                                    <div class="col-2">
                                        <b>{{ $language.eveDate }}</b>
                                    </div>
                                    <div class="col-10">{{ status.EventDate }}</div>
                                </div>
                                <div class="row bottomBorder" v-if="status.LegalEventCode1">
                                    <div class="col-2">
                                        <b>{{ $language.eveCode }}</b>
                                    </div>
                                    <div class="col-10">{{ status.LegalEventCode1 }}</div>
                                </div>
                                <div class="row bottomBorder" v-if="status.RwsLegalEventCode">
                                    <div class="col-2">
                                        <b>{{ $language.eveGroup }}</b>
                                    </div>
                                    <div class="col-10">{{ status.RwsLegalEventCode }}</div>
                                </div>
                                <div class="row" v-if="status.Description">
                                    <div class="col-2">
                                        <b>{{ $language.eveDetails }}</b>
                                    </div>
                                    <div class="col-10">{{ status.Description }}</div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="docSection" id="images" v-if="memberData.c_drawingscount">

                    <div class="sectionHeader">
                        {{ $language.imgs }}
                    </div>

                    <div class="content container-fluid">

                        <div class="row imgRow">

                            <img @click="showLightBox(n)" :src="imgUrl + n" v-for="n in memberData.c_drawingscount" />

                        </div>

                    </div>
                </div>
            </div>

            <exportMember v-if="!isExport" :inner="memberHtml"></exportMember>

        </div>
    `,
    data: function() {
        return {
            membersFullData: {},
            memberData: {},
            memberHtml: '',
            link: {
                url: null,
                tooltip: '',
                logo: ''
            }
        };
    },

    mixins: [showLinkMixin],

    props: {
        fn: Number,
        isExport: {
            type: Boolean,
            default: false
        },
        exportMemberPn: {
            type: String,
            default: null
        },
        exportMemberKd: {
            type: String,
            default: null
        },
        exportData: Object
    },

    mounted() {
        this.getMemberFullData(true)
    },

    watch: {

        pn(newPn, oldPn) {

            if (!this.membersFullData[newPn]) {
                this.getMemberFullData(false);
            } else {
                this.memberData = this.membersFullData[newPn];
                this.setLink();
            }
            this.$refs.docWrapper.scrollTop = 0;
        }

    },

    computed: {
        members() {
            return this.$store.getters.membersData;
        },

        member() {
            if (!this.isExport) {
                return this.members[this.$store.getters.currentMember];
            } else {
                return this.memberData;
            }
        },

        pn() {
            if (this.isExport) {
                return this.exportMemberPn + this.exportMemberKd;
            } else {
                return this.member.c_publicationnumber + this.member.c_kindcode;
            }
        },

        imgUrl() {
            if (this.isExport) {
                return 'https://www.patbase.com/phpmosaic/getone.php?pn=' + this.exportMemberPn + '&kd=' + this.exportMemberKd + '&pg=';
            } else {
                return 'https://www.patbase.com/phpmosaic/getone.php?pn=' + this.member.c_publicationnumber + '&kd=' + this.member.c_kindcode + '&pg=';
            }
        },

        imgs() {
            if (this.memberData) {
                let ret = [];
                for (var i = 1; i <= this.memberData.c_drawingscount; i++) {
                    ret.push(this.imgUrl + i);
                }
                return ret;
            }
        },

        espacenetLink() {
            let kd = this.memberData.c_kindcode;
            let pn = this.memberData.c_publicationnumber;

            if (this.memberData.c_docdbpublicationnumber) {
                pn = this.memberData.c_docdbpublicationnumber;
            }
            if (this.memberData.c_docdbkindcode) {
                kd = this.memberData.c_docdbkindcode;
            }
            return 'https://worldwide.espacenet.com/patent/search?q=pn%3D'+ pn + kd;

        }
    },

    methods: {

        getMemberFullData(firstLoad) {

            if (!this.isExport) {

                EventBus.$emit('SHOW_LOADING', true);

                let pn, kd;

                if (this.isExport) {
                    pn = this.exportMemberPn;
                    kd = this.exportMemberKd;
                } else {
                    pn = this.member.c_publicationnumber;
                    kd = this.member.c_kindcode;
                }

                this.$store.dispatch('GET_MEMBER_FULL_DATA', {
                        pn,
                        kd
                    })
                    .then(res => {

                        this.membersFullData[this.pn] = res.data[0];
                        this.memberData = res.data[0];

                        this.$nextTick()
                            .then(() => {

                                $('[data-spy="scroll"]').each(function() {
                                    var $spy = $(this).scrollspy('refresh')
                                });

                                if (firstLoad && window.location.hash.length > 0) {
                                    if (document.getElementById(window.location.hash.replace('#', ''))) {
                                        document.getElementById(window.location.hash.replace('#', '')).scrollIntoView();
                                    }
                                }

                            });


                        this.setLink();
                        EventBus.$emit('HIDE_LOADING');

                    })
                    .catch(err => {
                        console.log(err);
                        EventBus.$emit('HIDE_LOADING');
                    });

            } else {
                this.memberData = this.exportData;
                this.setLink();
            }

        },

        buildLangString(string) {

            let newString = '';

            newString += "<b>[" + string.replace(/<div lang="(.*?)".?>(.*)<\/div>/i, '$1').toUpperCase() + "]</b> ";
            newString += string.replace(/<div lang="(.*?)".?>(.*)<\/div>/i, '$2');

            return newString;

        },

        removeBrs(string) {
            let reg = /(<\/?br>){2,}/ig;
            return string.replace(reg, '<br>')
        },

        removeTag(string) {
            let reg = /<div .+>(.+)<\/div>/i;
            return string.replace(reg, '$1');
        },

        readJSON(string) {
            if (string) {
                let ret = JSON.parse(string);
                return ret;
            } else {
                return  [];
            }
        },

        showLightBox(n) {
            EventBus.$emit('SHOW_LIGHTBOX', {
                imgs: this.imgs,
                index: n
            });
        },

        uniqueTitles(array) {

            let titles = [];

            let langRegex = /<div.*?lang="(.*?)".*?>.*?<\/div>/gi;
            let titleRegex = /<div.*?>(.*?)<\/div>/gi;

            let hasMt = false;
            let hasEn = false;
            let mtIndex = null;

            array.forEach(title => {
                titles.push({
                    lang: title.replace(langRegex, '$1'),
                    text: title.replace(titleRegex, '$1')
                });
                if (titles[titles.length - 1].lang == 'mt') {
                    hasMt = true;
                    mtIndex = titles.length - 1;
                }
                if (titles[titles.length - 1].lang == 'en') {
                    hasEn = true;
                }
            });

            // https://dev.patbase.com/familyexplorer/public/index.php?fn=56849362&pn=CN103913798&kd=B

            if (hasMt && hasEn) {
                titles.splice(mtIndex, 1);
            }

            // //get unique titles (prevents mt from english titles)
            // let uniq = Array.from(new Set(titles.map(title => title.text)))
            //     .map(text => {
            //         return {
            //             text,
            //             lang: titles.find(title => title.text === text).lang
            //         };
            //     });
            //
            // if (uniq.length == 0 && titles.length > 0) { //for some reason, in ie, uniq is empty
            //     return titles;
            // }
            //
            // if (uniq.find(title => title.lang == 'mt') && uniq.find(title => title.lang == 'en') {
            //
            // }

            return titles;
        },

        formatApplicationNumber(an) {

            let applicationArray = an.split('');
            let formatedAn = an;
            if (applicationArray[0] == 'U' && applicationArray[1] == 'S') {

                //us series number: 12/345,678
                applicationArray = applicationArray.slice(2);
                applicationArray.splice(2, 0, '/');
                applicationArray.splice(6, 0, ',');
                formatedAn = applicationArray.join('');

            }

            return formatedAn;

        },

        printMember() {
            window.print();
        },

        exportHtml() {

            var elHtml = document.getElementById('documentContent').innerHTML;
            this.memberHtml = elHtml;
            EventBus.$emit('EXPORT_MEMBER', this.pn);

        },

        sendEmail() {
            EventBus.$emit('showShare');
        },

        //function add leading zeros to update weeks
        paddy(num, padlen, padchar) {
            var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
            var pad = new Array(1 + padlen).join(pad_char);
            return (pad + num).slice(-pad.length);
        },

        getNames(json) {
            var names = [];
            if (json) {
                var array = this.readJSON(json);
                array.forEach(item => {
                    names.push(item.Name);
                });
            }
            return names;
        },

        buildPriorityString(priorities) {
            var ret = [];
            var priorityArray = this.readJSON(priorities);

            priorityArray.forEach(priority => {
                ret.push(priority.Number + ' [' + priority.Date + ']');
            });

            return ret.join(' | ');
        },

        hasMt(section) {

            var mt = false;

            if (this.memberData['c_' + section + '_mt']) {
                mt =  this.memberData['c_' + section + '_mt'][0];
            } else {
                this.memberData['c_' + section].forEach(lang => {
                    if (lang.match(/lang="mt"/)) {
                        mt = lang;
                    }
                });
            }
            return mt;

        },

        showMt(section) {
            var showMt = true;

            if (this.memberData['c_' + section]) {
                this.memberData['c_' + section].forEach(lang => {
                    if (lang.match(/lang="en"/)) {
                        showMt = false;
                    }
                });
            }

            return showMt;
        },

        getMainTitle(titles) {

            let langRegex = /<div.*?lang="(.*?)".*?>.*?<\/div>/gi;

            let mainTitle = '';
            let langTitle = '';

            titles.forEach(title => {
                var lang = title.replace(langRegex, '$1');

                if (mainTitle == '') {
                    mainTitle = this.removeTag(title);
                    langTitle = lang;
                }

                if (lang == 'en' || (lang == 'mt' && langTitle != 'en')) {
                    mainTitle = this.removeTag(title);
                    langTitle = lang;
                }
            });

            return mainTitle;
        },

        setLink() {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            let kd = this.memberData.c_kindcode;
            let pn = this.memberData.c_publicationnumber;

            if (this.memberData.c_docdbpublicationnumber) {
                pn = this.memberData.c_docdbpublicationnumber;
            }
            if (this.memberData.c_docdbkindcode) {
                kd = this.memberData.c_docdbkindcode;
            }

            switch (this.memberData.c_country) {
                case 'WO':
                    this.link.url = 'https://patentscope.wipo.int/search/en/detail.jsf?docId=' + pn;
                    this.link.logo = 'patentscope';
                    this.link.tooltip = 'Patentscope';
                    break;

                case 'US':
                    this.link.url = 'https://www.patbase.com/getimg/uspto.asp?PN=' + pn + '+' +kd;
                    this.link.logo = 'uspto';
                    this.link.tooltip = 'USPTO';
                    break;

                // case 'EP':
                //     this.link.url = 'https://worldwide.espacenet.com/patent/search?q=pn%3D'+ pn + kd;
                //     this.link.logo = 'espacenet';
                //     this.link.tooltip = 'Espacenet';
                //     break;
                default:
                    this.link.url = null;
                    break;
            }

            this.$nextTick().then(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });

        }
    }
});
